<template>
  <div class="card">
    <ul class="list-group list-group-flush">
      <li class="list-group-item pt-0 pr-0 pb-0 pl-0">
        <button
          style="height:36px"
          disabled
          v-if="uploading"
          class="text-center btn btn-light btn-block mb-0"
        >
          <i class="fa fa-spinner fa-spin"></i>
        </button>
        <label style="height:36px" v-else class="btn btn-light btn-block mb-0">
          <i class="far fa-plus-circle"></i> Upload
          <input
            @change="uploadFile($event)"
            type="file"
            style="display: none;"
            :class="{ 'is-invalid': errors.has('file') }"
            name="file"
            multiple
          />
          <div v-show="errors.has('file')" class="invalid-feedback">
            Please upload only images
          </div>
        </label>
      </li>
      <li v-for="(file, index) in files" class="list-group-item">
        {{ file.name }}
        <a
          href="#"
          class="freight-row-delete file-row-delete"
          @click.prevent="deleteFile(index)"
        >
          <i class="far fa-minus-circle"></i>
          <span class="hidden-lg-up">Remove row</span>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "file-uploader",
  inject: ["$validator"],
  props: ["files"],

  data() {
    return {
      uploading: false,
      file: null
    };
  },

  methods: {
    deleteFile(index) {
      this.$emit("deleted", index);
    },

    uploadFile(event) {
      this.uploading = true;

      let numFiles = event.target.files.length;

      for (var index in event.target.files) {
        if (index == "length" || index == "item") {
          return true;
        }

        var form = new FormData();

        form.append("file", event.target.files[index]);

        axios
          .post("/customer-files", form, {
            headers: {
              Accept: "application/json",
              "Content-Type": "multipart/form-data"
            }
          })
          .then(response => {
            if (numFiles == 1) {
              this.uploading = false;
            }

            numFiles--;
            this.$emit("uploaded", response.data.data);
          })
          .catch(error => {
            Event.$emit("serverError");
          });
      }
    }
  }
};
</script>
